/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAwsOrganizationUnit extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAwsOrganizationUnit");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAwsOrganizationUnit.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAwsOrganizationUnit>): ServiceAccountNativeDetailsForAwsOrganizationUnit {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAwsOrganizationUnit(), model);
        ServiceAccountNativeDetailsForAwsOrganizationUnit.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAwsOrganizationUnit>): ServiceAccountNativeDetailsForAwsOrganizationUnit {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAwsOrganizationUnit.newInstance(<ServiceAccountNativeDetailsForAwsOrganizationUnit> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAwsOrganizationUnit) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAwsOrganizationUnit.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAwsOrganizationUnit): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAwsOrganizationUnit.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization Unit Name
     */
    organization_unit_name: string;

    /**
     * Organization Unit Id
     */
    organization_unit_id: string;

}
